/* eslint-disable require-jsdoc */
/* eslint-disable no-unused-vars */
import { Base } from '@studiometa/js-toolkit';
import { damp } from '@studiometa/js-toolkit/utils';

/**
 * Canvas component
 */
export default class Canvas extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Canvas',
    refs: ['canvas'],
  };

  /**
   * @type {CanvasRenderingContext2D}
   */
  context = null;

  width = 0;

  height = 0;

  mounted() {
    this.drawRect = false;

    this.width = this.$refs.canvas.offsetWidth;
    this.height = this.$refs.canvas.offsetHeight;
    this.$refs.canvas.setAttribute('width', this.width);
    this.$refs.canvas.setAttribute('height', this.height);
    // @ts-ignore
    this.context = this.$refs.canvas.getContext('2d');
    // this.context.rotate(Math.PI / 2);
    this.radius = 30;
    this.x = this.radius;
    this.y = this.radius;
    this.click = false;

    // @ts-ignore
    this.context.fillStyle = '#FFF';
    this.context.fillRect(0, 0, this.width, this.height);
    this.draw();
  }

  /**
   * Recalculate width and height
   * @returns {void}
   */
  resized() {
    this.width = this.$refs.canvas.offsetWidth;
    this.height = this.$refs.canvas.offsetHeight;
  }

  /**
   * Let's draw !
   * @returns {void}
   */
  onCanvasMousedown() {
    this.click = true;
    if (this.click) this.draw();
  }

  /**
   * Stop drawing
   * @returns {void}
   */
  onCanvasMouseup() {
    this.click = false;
  }

  /**
   * Detect mouse position in canvas
   * @param  {object} e
   * @returns {void}
   */
  onCanvasMousemove(e) {
    const rect = e.currentTarget.getBoundingClientRect();
    this.x = damp(this.x, e.clientX - rect.left, 0);
    this.y = damp(this.y, e.clientY - rect.top, 0);
  }

  /**
   * Draw some stuffs
   * @returns {void}
   */
  draw() {
    if (!this.click) return;

    if (this.drawRect) {
      this.context.fillStyle = '#FFF';
      this.context.fillRect(0, 0, this.width, this.height);
      this.drawRect = false;
    }

    this.context.globalCompositeOperation = 'destination-out';
    this.context.beginPath();
    this.context.arc(this.x, this.y, this.radius, 100, Math.PI * 2, true);
    this.context.fillStyle = 'red';
    this.context.closePath();
    this.context.fill();

    requestAnimationFrame(this.draw.bind(this));
  }
}
